<template>
  <div class="childPannel">
    <el-input
      v-model="filterValue"
      style="width: 100%; margin-bottom: 12px"
      placeholder="通过名称进行搜索"
      :prefix-icon="Search"
    />
    <div v-if="list.length" class="childPannel-box">
      <div
        @click=handleClickItem(m)
        v-for="(m, i) in list"
        :key="i"
        class="childPannel-box-item"
      >
        <div class="childPannel-box-item-block">
          <div class="childPannel-box-item-block-info">
            <span class="childPannel-box-item-block-info-label">名称：</span>
            <span class="childPannel-box-item-block-info-value">{{ m.name }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-empty :image-size="100" v-else description="当前内容为空" />
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { gaugingStationList } from './staticData'
import { toCameraPosition } from './utils'
import { Search } from '@element-plus/icons-vue'

const filterValue = ref('')
const list = computed(() => {
  return gaugingStationList.filter((m) => {
    const str = m.name
    return str.includes(filterValue.value)
  })
})

import { Cartographic, Math } from 'cesium'
import { LayerPopupCtrl } from '@/components/LayerPopupCtrl'
import { CesiumObj } from '@/components/GIS/CesiumObj'
import WaterlevelPopup from '../../Popup/WaterlevelPopup.vue'


const popupCtrl = LayerPopupCtrl.getInstance();
let cesiumobj: CesiumObj | null = null

const handleClickItem = async (m: { id:number,name:string, longitude:number, latitude: number },) => {
  if (!cesiumobj) cesiumobj = await CesiumObj.getInstance()
    popupCtrl.popupMap.forEach((val) => {
      val.destroy()
    })

  toCameraPosition({
    lng: m.longitude,
    lat: m.latitude,
  })
  const cartographic = Cartographic.fromDegrees(m.longitude, m.latitude, 0)
  popupCtrl.popup({
    viewer: cesiumobj.viewer,
    id: m.id,
    lnglat: [cartographic.longitude, cartographic.latitude].map(Math.toDegrees) as [number, number],
    Com: WaterlevelPopup,
    properties: m,
  })
}
</script>

<style lang="scss" scoped>
@import url('./childPannel.scss');
</style>
